import React, { type ReactNode } from 'react';

import LockLockedIcon from '@atlaskit/icon/utility/lock-locked';
import { Inline } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl/src';
import messages from './messages.tsx';

export const LockOption = ({ children }: { children: ReactNode }) => {
	const { formatMessage } = useIntl();

	return (
		<Inline space="space.100">
			{children}
			<Tooltip
				content={formatMessage(messages.scimManagedOrganizationTooltipNonFinal)}
				position="right-start"
			>
				<LockLockedIcon
					label={formatMessage(messages.scimManagedOrganizationLockIconLabelNonFinal)}
					testId="servicedesk-customers-organization-common.common.ui.organizations-select-field.organizations-single-select.lock-option.lock-filled-icon"
					color={token('color.icon.disabled')}
					spacing="none"
				/>
			</Tooltip>
		</Inline>
	);
};
